import { Link as MuiLink, LinkProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface ExtendedLinkProps extends LinkProps {
  showArrow?: boolean;
}

export const Link: React.ComponentType<ExtendedLinkProps> = styled(MuiLink, {
  shouldForwardProp: (prop) => prop !== 'showArrow',
})<ExtendedLinkProps>(({ showArrow = false }) => ({
  textDecoration: 'none',
  ...(showArrow && {
    [`&::after`]: {
      content: '" ↗"',
      fontWeight: 450,
    },
  }),
}));
